import React from 'react';
import classNames from 'classnames';
import { GENERAL } from '../constants';
import { connectToJSContext } from '../utils.jsx';
import { phoneFormat, formatHref } from '../../common/utils';

const ContactItem = ({ description, value}) => {
    return (
        <div className="row contact-item">
            {description &&
                <strong className="contact-description col-xs-12 col-sm-3">
                    {description}
                    <span className="hidden-xs">:</span>
                </strong>
            }
            {value}
        </div>
    );
};

const ContactValueItem = ({ description, displayValue, href }) => {
    return (
        <span
            className={classNames(
                'contact-value col-xs-12 col-sm-9',
                { 'col-sm-offset-3': !description }
            )}
        >
            {href ? <a className="contact-value__link" href={href}>{displayValue}</a> : displayValue}
        </span>
    );
};

const AddressItem = ({ addressLabel, city, state, zip_code, street, suite }) => {
    return (
        <p className={classNames(
            'contact-value col-xs-12 col-sm-9',
            { 'col-sm-offset-3': !addressLabel }
        )}
        >
            <span
                itemProp="streetAddress office-location__street-address"
            >
                {street}
            </span>
            <br />
            {suite &&
                <span className="office-location__suite">
                    {suite}<br />
                </span>
            }
            <span itemProp="addressLocality office-location__city">{city}</span>,
            <span itemProp="addressRegion office-location__state"> {state}</span>
            <span itemProp="postalCode office-location__zip-code"> {zip_code}</span>
        </p>
    );
};

const ProfileContact = ({
    phoneLabel,
    emailLabel,
    addressLabel,
    phone,
    email,
    address
}) => (
    <div className="c-profile__contact">
        {phone &&
            <ContactItem
                description={phoneLabel}
                value={
                    <ContactValueItem
                        description={phoneLabel}
                        displayValue={phoneFormat(phone, true).readable}
                        href={formatHref("tel", phoneFormat(phone, true).link)}
                    />
                }
            />
        }
        {email &&
            <ContactItem
                description={emailLabel}
                value={
                    <ContactValueItem
                        description={emailLabel}
                        displayValue={email}
                        href={formatHref("mailto", email)}
                    />
                }
            />
        }
        {address &&
            <ContactItem
                description={addressLabel}
                value={
                    <AddressItem
                        addressLabel={addressLabel}
                        city={address.city}
                        state={address.state}
                        zip_code={address.zip_code}
                        street={address.street}
                        suite={address.suite}
                    />
                }
            />
        }
    </div>
);

const mapStateToProps = ({theme_data}) => {
    return {
        phoneLabel: (theme_data.labels && theme_data.labels.location_phone) || GENERAL.CONTACT.PHONE,
        emailLabel: (theme_data.labels && theme_data.labels.location_email) || GENERAL.CONTACT.EMAIL,
        addressLabel: (theme_data.labels && theme_data.labels.location_address) || GENERAL.CONTACT.ADDRESS
    };
};

export default connectToJSContext(mapStateToProps)(ProfileContact);



// WEBPACK FOOTER //
// ./components/profile/profile_contact.jsx